<template>
  <div class="view import-companies">
    <div class="content">
      <div class="title">{{ $t('importCompanies.title') }}</div>
      <div class="title-content">
        <div class="line">{{ $t('importCompanies.onlyRcs') }}</div>
        <div class="line">{{ $t('importCompanies.onlyAvailableDocument') }}</div>
      </div>

      <div class="title">{{ $t('prerequisites') }}</div>
      <div class="title-content arrow">
        <div class="line">{{ $t('importCompanies.onlyCsv') }}</div>
        <div class="line">
          {{ $t('importCompanies.format.title') }}<b>{{ $t('importCompanies.format.content') }}</b>
        </div>
        <div class="line">{{ $t('importCompanies.columnOrder') }}</div>
        <div class="line">{{ $t('importCompanies.sirenAtLeastNineNumber') }}</div>
        <div class="line">
          {{ $t('importCompanies.monitoringInfos.title') }}<b>{{ $t('importCompanies.monitoringInfos.0') }}</b
          >{{ $t('importCompanies.monitoringInfos.1') }}
        </div>
        <div class="line">
          {{ $t('importCompanies.theField') }} <b>{{ $t('internalId') }}</b> {{ $t('importCompanies.canBeEmpty') }}
        </div>
      </div>

      <div class="file-modal" @click="downloadExampleCsv">
        <IconImport />
        <div class="link-button">{{ $t('upload.downloadModalCsv') }}</div>
      </div>

      <div class="file-handler">
        <div class="title">{{ $t('upload.selectFile') }}</div>
        <div class="file">
          <div class="main-button" @click="openInput">{{ $t('upload.chooseFile') }}</div>
          <div class="status" :class="{ green: fileName !== $t('upload.noFile') }">
            <IconCheck v-if="fileName !== $t('upload.noFile')" class="icon greenColor" />{{ fileName }}
          </div>
        </div>
      </div>

      <div class="send">
        <div class="cancel main-button" @click="$router.go(-1)">{{ $t('cancel') }}</div>
        <div class="main-button" :class="{ disabled: !file }" @click="send">
          <div v-if="loading" class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          {{ !loading ? $t('importCompanies.send') : '' }}
        </div>
      </div>
      <input :ref="'inputFile'" type="file" accept=".csv" class="input-file" hidden @change="uploadFile({}, $event)" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      fileName: this.$t('upload.noFile'),
      fileError: false,
      file: null,
    };
  },

  computed: {
    ...mapGetters(['isLogged', 'user']),
  },

  methods: {
    downloadExampleCsv() {
      const rows = [
        ['Siren', 'NiveauDeSurveillance', 'LabelDeSurveillance', 'ReferenceInterne', 'Prenom et Nom Gestionnaire'],
        ['123456789', '9', 'Important', 'Ma référence interne', 'John Doe'],
      ];
      let csvContent = 'data:text/csv;charset=utf-8,' + rows.map(e => e.join(';')).join('\n');
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'example_kyc_infogreffe.csv');
      document.body.appendChild(link); // Required for FF
      link.click();
    },

    async send() {
      if (!this.file) return;
      this.loading = true;
      await this.$store.dispatch('uploadImportCompanyFile', { data: this.file });
      this.loading = false;
      this.$router.push('/history/group');
    },

    async uploadFile(_, event) {
      if (!event.target.files[0]) {
        return;
      }
      this.fileName = event.target.files[0].name;
      const data = new FormData();
      data.append('file', event.target.files[0]);
      this.file = data;
    },

    openInput() {
      this.$refs[`inputFile`].click();
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
* {
  box-sizing: border-box;
}

.input-file {
  display: none;
}

.view {
  padding: 170px 0 64px;
  box-sizing: border-box;
  color: colors.$black-color;

  .content {
    display: flex;
    flex-direction: column;

    .title {
      font-weight: 500;
      font-size: 20px;
      color: colors.$darkblue-color;
      margin: 20px 0 20px;
    }

    .title-content {
      :last-child {
        margin: 0 0 20px;
        font-size: 15px;
      }

      .line {
        font-size: 15px;
        line-height: 30px;
      }

      &.arrow {
        .line {
          position: relative;
          padding: 0 40px 0;

          &:before {
            position: absolute;
            content: '';
            left: 16px;
            top: 12px;
            bottom: 0;
            width: 6px;
            height: 6px;
            border-bottom: 1px solid colors.$lightblue-color;
            border-right: 1px solid colors.$lightblue-color;
            transform: rotate(-45deg);
          }
        }
      }
    }

    .file-modal {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      color: colors.$lightblue-color;
      margin-bottom: 20px;

      .link-button {
        margin-left: 8px;
      }
    }

    .file-handler {
      margin-bottom: 80px;
      .title {
        font-weight: 500;
        font-size: 17px;
        color: colors.$darkblue-color;
      }

      .file {
        display: flex;
        align-items: center;

        .main-button {
          background: colors.$lightblue-color;
          border-radius: 4px;
          font-size: 14px;
          height: 30px;
          padding: 0;
          min-width: 160px;
          width: 160px;
        }

        .status {
          margin-left: 32px;
          font-size: 13px;
          color: colors.$lightgrey-color;
          display: flex;
          align-items: center;

          &.green {
            color: colors.$lightgreen-color;
          }

          .icon {
            border-radius: 50%;
            margin-right: 12px;
          }
        }
      }
    }
  }
  .send {
    display: flex;

    .main-button {
      width: 280px;

      &.cancel {
        width: 120px;
        margin-right: 30px;
        background: colors.$lightgrey-color;
        color: colors.$darkgrey-color;
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
}
</style>
